import { UIMatch } from 'react-router-dom';
import { RouteHandleBreadcrumb } from '@/types/route-handle-breadcrumb';

export const matchHasCrumb = (
  match: UIMatch<unknown, undefined | { crumb?: RouteHandleBreadcrumb }>,
): match is UIMatch<unknown, { crumb: RouteHandleBreadcrumb }> =>
  Boolean(match.handle?.crumb);
